<template>
    <div class="CheckboxView u-InputMarginView"
        :class="[modes.map((m) => `CheckboxView--${m}`), { 'u-ErrorView': hasError }]">
        <div class="CheckboxView-wrapper">
            <label class="CheckboxViewLabel" :for="`CheckboxView-input-${_uid}`" v-if="!!title">
                <input class="CheckboxViewInput" type="checkbox" v-model="innerValue" :id="`CheckboxView-input-${_uid}`" />
                <span :class="this.value && 'active'">{{ title }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CheckboxView',
    mixins: [mixins.ValidationComponentMixin],
    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        },
        modes: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="less">
@import "~styles/const.less";

@r: .CheckboxView;

@{r} {
    width: fit-content;

    &-wrapper {
        position: relative;
    }

    &Label {
        display: flex;
        align-items: center;
        font-family: @Graphik-LCG;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;

        span {
            display: block;
            padding-left: 10px;
            font-size: 12px;
            line-height: 16px;

            &:before {
                content: " ";
                position: absolute;
                left: 4px;
                bottom: 8px;
                width: 12px;
                height: 8px;
                border-color: black;
                border-width: 0 0 1px 1px;
                border-style: solid;
                transform: rotate(-45deg);
                opacity: 0;
            }
        }

        &:before {
            content: " ";
            width: 20px;
            height: 20px;
            background: transparent;
            border: 1px black solid;
        }
    }

    &Input {
        display: none;
        visibility: hidden;

        &:checked+span {
            &:before {
                opacity: 1;
            }
        }
    }
}

.u-ShowErrors @{r}.u-ErrorView @{r}Input {
    border-color: red;
}
</style>
